var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column window-height"},[_c('ApplicationHeader'),_c('QLayout',{staticClass:"col-grow app-layout",attrs:{"view":"lHh lpr lFf","container":""}},[_c('ProgressHeader'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }